/**
 * Decodes HTML entities like &lt; &gt; &amp; into actual characters.
 * Runs multiple passes to handle encoded HTML stored as text.
 */
export function decodeHtmlEntities(input: string, maxPasses = 2): string {
	if (!input) return '';

	let current = input;

	for (let i = 0; i < maxPasses; i++) {
		const textarea = document.createElement('textarea');
		textarea.innerHTML = current;
		const decoded = textarea.value;

		// Stop early if nothing changes
		if (decoded === current) break;

		current = decoded;
	}

	return current;
}
